/* Global effects: custom cursor, fallback page transition, image placeholders.
   Everything is switched by data-nt-* flags on <html> (set from Theme settings by snippets/theme-effects.liquid). */
(() => {
  if (window.__ntEffects) return;
  window.__ntEffects = true;
  const html = document.documentElement;
  const ds = html.dataset;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Custom cursor ------------------------------------------------------- */
  if (ds.ntCursor && finePointer && !reduced) {
    const dot = document.createElement('div');
    dot.className = 'nt-cursor';
    dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(dot);
    const target = { x: -100, y: -100 };
    const pos = { x: -100, y: -100 };
    let raf = 0;
    const ease = ds.ntCursor === 'dot' ? 0.4 : 0.2;
    const tick = () => {
      pos.x += (target.x - pos.x) * ease;
      pos.y += (target.y - pos.y) * ease;
      dot.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      raf = Math.abs(target.x - pos.x) + Math.abs(target.y - pos.y) > 0.3 ? requestAnimationFrame(tick) : 0;
    };
    const interactive = 'a[href], button, summary, label, select, [role="button"], input[type="submit"], input[type="checkbox"], input[type="radio"]';
    document.addEventListener('pointermove', (e) => {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      target.x = e.clientX;
      target.y = e.clientY;
      if (!dot.classList.contains('is-on')) {
        pos.x = target.x;
        pos.y = target.y;
        dot.classList.add('is-on');
        html.classList.add('nt-cursor-live');
      }
      dot.classList.toggle('is-link', !!(e.target.closest && e.target.closest(interactive)));
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
    document.addEventListener('pointerleave', () => dot.classList.remove('is-on'));
    document.documentElement.addEventListener('mouseleave', () => dot.classList.remove('is-on'));
  }

  /* Fallback page transition (browsers without cross-document view transitions) */
  if (ds.ntPageTransition && html.classList.contains('nt-pt-fallback') && !reduced && !(window.Shopify && Shopify.designMode)) {
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      let url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      if (/^\/(cart|checkout|account\/logout)/.test(url.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''))) return;
      e.preventDefault();
      html.classList.add('nt-leaving');
      setTimeout(() => { location.href = url.href; }, 190);
    });
    window.addEventListener('pageshow', (e) => { if (e.persisted) html.classList.remove('nt-leaving'); });
  }

  /* Image placeholders: lazy images stay blurred / hidden until loaded. */
  if (ds.ntPlaceholder && ds.ntPlaceholder !== 'none') {
    const settle = (img) => {
      if (!img.classList.contains('nt-img-wait')) return;
      img.classList.remove('nt-img-wait');
      img.classList.add('nt-img-done');
      setTimeout(() => img.classList.remove('nt-img-done'), 700);
    };
    const watch = (img) => {
      if (img.dataset.ntPh || img.complete || img.loading !== 'lazy') return;
      img.dataset.ntPh = '1';
      img.classList.add('nt-img-wait');
      img.addEventListener('load', () => settle(img), { once: true });
      img.addEventListener('error', () => settle(img), { once: true });
      setTimeout(() => settle(img), 8000);
    };
    const scan = (root) => {
      if (root.nodeType !== 1) return;
      if (root.tagName === 'IMG') watch(root);
      else root.querySelectorAll('img[loading="lazy"]').forEach(watch);
    };
    scan(document.body);
    new MutationObserver((list) => list.forEach((m) => m.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
  }
})();
